// 1. تعريف الأنواع لضمان توافق TypeScript
export type Language = 'en' | 'ar' | 'it';
export type Direction = 'ltr' | 'rtl';

interface LanguageConfig {
  readonly code: Language; // جعل الخصائص للقراءة فقط لحماية البيانات
  readonly label: string;
  readonly short: string;
  readonly dir: Direction;
  readonly flag: string;   // إزالة الـ '?' لأن كل لغاتك حالياً تملك أعلاماً
}

// 2. مصفوفة اللغات (إضافة 'as const' تجعل التيبيسكريبت يتعامل معها بدقة متناهية)
export const LANGUAGES: readonly LanguageConfig[] = [
  {
    code: 'en',
    label: 'English',
    short: 'EN',
    dir: 'ltr',
    flag: '🇬🇧',
  },
  {
    code: 'ar',
    label: 'العربية',
    short: 'AR',
    dir: 'rtl',
    flag: '🇪🇬',
  },
  {
    code: 'it',
    label: 'Italiano',
    short: 'IT',
    dir: 'ltr',
    flag: '🇮🇹',
  }
] as const;

// 3. الإعدادات الافتراضية المجمعة
export const i18nConfig = {
  defaultLanguage: 'en' as Language,
  fallbackLanguage: 'en' as Language,
  cookieName: 'NEXT_LOCALE',
  // استخراج الأكواد فقط لاستخدامها في Middleware أو Validation
  locales: LANGUAGES.map(l => l.code),
} as const;

// 4. وظائف مساعدة (Helpers) - محسنة للأداء والوضوح
/** الحصول على بيانات اللغة بالكامل */
export const getLanguageByCode = (code: string): LanguageConfig => 
  LANGUAGES.find((lang) => lang.code === code) || LANGUAGES[0];

/** دالة سريعة للتحقق من الاتجاه (مفيدة جداً في التنسيقات والأنميشن) */
export const isRTL = (code: Language): boolean => getDirection(code) === 'rtl';

/** الحصول على الاتجاه مباشرة */
export const getDirection = (code: Language): Direction => 
  LANGUAGES.find((lang) => lang.code === code)?.dir || 'ltr';

/** دالة ذكية للتبديل الدوري (لجعل الزر في الهيدر يعمل آلياً) */
export const getNextLanguageCode = (currentCode: Language): Language => {
  const currentIndex = LANGUAGES.findIndex(l => l.code === currentCode);
  const nextIndex = (currentIndex + 1) % LANGUAGES.length;
  return LANGUAGES[nextIndex].code;
};